export default {"src":"/_next/static/media/redacto-woopsie.c4ce0285.svg","height":430,"width":541,"blurWidth":0,"blurHeight":0};